import { render } from "./CoReg_Period.vue?vue&type=template&id=2a3efce5&scoped=true"
import script from "./CoReg_Period.vue?vue&type=script&lang=js"
export * from "./CoReg_Period.vue?vue&type=script&lang=js"

import "./CoReg_Period.vue?vue&type=style&index=0&id=2a3efce5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3efce5"]])

export default __exports__